// This file is used to report web vitals to your analytics service or logging platform

export default function reportWebVitals(metric) {
    // Log the metric to your analytics service or logging platform
    console.log(metric);
}